// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".botbreak-message{padding:16px;padding-top:24px;max-width:1000px}\n", ""]);
// Exports
module.exports = exports;
